import React, { useEffect } from 'react';
import PlPastQuarterlySidebar from '@molecules/pursuitLeader/components/plPastquarterlySideBar';
import {
  SidebarWrapper,
  SidebarTitle,
  ChevronIcon,
  SidebarShowHideIcon,
} from '@atoms/sidebar/sidebar.styles';
import { isMobile, isTablet } from 'react-device-detect';
import DownChevron from '@assets/icons/down-chevron.png';
import { Recoil_Summary_Drawer_Toggle, SidebarExpandCollapseState } from '@recoil/recoil';
import { useRecoilState } from 'recoil';
import { MotifButton } from '@ey-xd/motif-react';

const PlPastSideBar = props => {
  const screenWidth = window.innerWidth;

  const [summaryDrawerToggle, setSummaryDrawerToggle] = useRecoilState(
    Recoil_Summary_Drawer_Toggle,
  );
  const [sidebarExpandState, setSidebarExpandState] = useRecoilState(SidebarExpandCollapseState);

  useEffect(() => {
    if (localStorage.getItem('isSidebarExpanded')) {
      setSidebarExpandState(JSON.parse(localStorage.getItem('isSidebarExpanded')));
    }
  }, []);

  const onTitleClick = () => {
    // isTablet || isMobile ? setSummaryDrawerToggle(!summaryDrawerToggle) : null;
    if (isMobile || isTablet) {
      setSummaryDrawerToggle(!summaryDrawerToggle);
    }
  };

  const onExpandCollapseClick = () => {
    setSidebarExpandState(!sidebarExpandState);
    localStorage.setItem('isSidebarExpanded', !sidebarExpandState);
  };

  const handleKeyPress = event => {
    if (event.code === 'Enter' || event.code === 'Space') {
      onExpandCollapseClick();
    }
  };

  const addFocus = event => {
    event.target.classList.add('focusContainer');
  };

  const removeFocus = event => {
    event.target.classList.remove('focusContainer');
  };

  return (
    <SidebarWrapper>
      <SidebarTitle onClick={onTitleClick}>
        {isMobile || isTablet ? (
          <ChevronIcon src={DownChevron} alt="Expand Icon" style={{ marginRight: '10px' }} />
        ) : null}

        {sidebarExpandState ? <h3>Summary</h3> : null}

        {!isMobile && screenWidth > 1170 ? (
          <SidebarShowHideIcon onKeyDown={handleKeyPress} onFocus={addFocus} onBlur={removeFocus}>
            <MotifButton
              onClick={onExpandCollapseClick}
              style={{ color: '#FFFF00', cursor: 'pointer', backgroundColor: 'transparent' }}
            >
              {sidebarExpandState ? 'Collapse' : 'Expand'}
            </MotifButton>
          </SidebarShowHideIcon>
        ) : null}
      </SidebarTitle>
      <PlPastQuarterlySidebar data={props.data} />
    </SidebarWrapper>
  );
};

export default PlPastSideBar;
